import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import RoleRoute from "@/components/RoleRoute";
import { useAuth } from "@/context/AuthContext";

import PublicLayout from "@/components/public/PublicLayout";
import PublicHome from "@/pages/public/Home";
import PublicNews from "@/pages/public/News";
import PublicTeams from "@/pages/public/Teams";
import PublicPlayers from "@/pages/public/Players";
import PublicContact from "@/pages/public/Contact";
import RegistrationForm from "@/pages/public/RegistrationForm";

import Login from "@/pages/auth/Login";
import Activation from "@/pages/auth/Activation";
import PasswordReset from "@/pages/auth/PasswordReset";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CoachDashboard from "@/pages/admin/CoachDashboard";
import Seasons from "@/pages/admin/Seasons";
import Teams from "@/pages/admin/Teams";
import Players from "@/pages/admin/Players";
import Parents from "@/pages/admin/Parents";
import Attendance from "@/pages/admin/Attendance";
import Matches from "@/pages/admin/Matches";
import MatchStats from "@/pages/admin/MatchStats";
import StatsLeaderboard from "@/pages/admin/StatsLeaderboard";
import Payments from "@/pages/admin/Payments";
import Announcements from "@/pages/admin/Announcements";
import News from "@/pages/admin/News";
import Homepage from "@/pages/admin/Homepage";
import Members from "@/pages/admin/Members";
import Registrations from "@/pages/admin/Registrations";
import ParentLayout from "@/components/parent/ParentLayout";
import ParentDashboard from "@/pages/parent/Dashboard";
import { ADMIN_ROLES } from "@/lib/roleRouting";

function App() {
    const AdminOnly = ({ children }) => <RoleRoute allowedRoles={["super_admin", "club_admin"]}>{children}</RoleRoute>;
    const Operations = ({ children }) => <RoleRoute allowedRoles={["super_admin", "club_admin", "coach", "staff"]}>{children}</RoleRoute>;
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    {/* Public site */}
                    <Route element={<PublicLayout />}>
                        <Route index element={<PublicHome />} />
                        <Route path="actualites" element={<PublicNews />} />
                        <Route path="equipes" element={<PublicTeams />} />
                        <Route path="joueurs" element={<PublicPlayers />} />
                        <Route path="contact" element={<PublicContact />} />
                        <Route path="inscription/:slug" element={<RegistrationForm />} />
                    </Route>

                    {/* Auth */}
                    <Route path="login" element={<Login />} />
                    <Route path="activation/:token" element={<Activation />} />
                    <Route path="reinitialisation-mot-de-passe/:token" element={<PasswordReset />} />

                    {/* Admin */}
                    <Route
                        path="admin"
                        element={
                            <RoleRoute allowedRoles={ADMIN_ROLES}>
                                <AdminLayout />
                            </RoleRoute>
                        }
                    >
                        <Route index element={<RoleDashboard />} />
                        <Route path="seasons" element={<AdminOnly><Seasons /></AdminOnly>} />
                        <Route path="teams" element={<AdminOnly><Teams /></AdminOnly>} />
                        <Route path="players" element={<Operations><Players /></Operations>} />
                        <Route path="parents" element={<AdminOnly><Parents /></AdminOnly>} />
                        <Route path="attendance" element={<Operations><Attendance /></Operations>} />
                        <Route path="matches" element={<Operations><Matches /></Operations>} />
                        <Route path="stats" element={<Operations><StatsLeaderboard /></Operations>} />
                        <Route path="stats/:matchId" element={<Operations><MatchStats /></Operations>} />
                        <Route path="payments" element={<Operations><Payments /></Operations>} />
                        <Route path="announcements" element={<Operations><Announcements /></Operations>} />
                        <Route path="news" element={<AdminOnly><News /></AdminOnly>} />
                        <Route path="homepage" element={<AdminOnly><Homepage /></AdminOnly>} />
                        <Route path="members" element={<AdminOnly><Members /></AdminOnly>} />
                        <Route path="registrations" element={<AdminOnly><Registrations /></AdminOnly>} />
                        <Route path="registrations/:registrationId" element={<AdminOnly><Registrations /></AdminOnly>} />
                    </Route>

                    <Route path="parent" element={<RoleRoute allowedRoles={["parent"]}><ParentLayout /></RoleRoute>}>
                        <Route index element={<ParentDashboard />} />
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
function RoleDashboard() {
    const { user, activeClubId } = useAuth();
    const role = user?.roles?.find((r) => r.club_id === activeClubId)?.role;

    if (role === "coach") return <CoachDashboard />;

    return <Dashboard />;
}
export default App;
